import {createRoot} from 'react-dom/client'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import {AuthProvider} from "./app/modules/auth/core/Auth";
import './index.css';
import { AppRoutes } from './app/routing/AppRoutes'
import { capturePushAttribution } from './utils/pushAttribution'
import { initPushification } from './utils/pushification'

Chart.register(...registerables)

// Atıf parametreleri yalnızca ilk yüklemede URL'de bulunur; SPA yönlendirmesi
// onları düşürmeden önce sekme oturumuna alınmalı.
capturePushAttribution()
initPushification()

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </MetronicI18nProvider>
    </QueryClientProvider>
  )
}
